
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manufacturer/[manufacturer_name]",
      function () {
        return require("private-next-pages/manufacturer/[manufacturer_name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manufacturer/[manufacturer_name]"])
      });
    }
  